export default __webpack_public_path__ + "components/weather-icon/static/daythunderstorm@2-72cd857fcd7c5d20749a2ff66f34d5b8.png";